import React, { useEffect } from "react";
import { FaTrashAlt } from "react-icons/fa";

const DeleteFranchiseModal = ({
    showDeleteModal,
    setShowDeleteModal,
    selectedFranchise,
    remark,
    setRemark,
    handleConfirmDelete,
    loading
}) => {


    const handleClose = () => {
        setShowDeleteModal(false);
    };

    // ESC close
    useEffect(() => {
        const esc = (e) => {
            if (e.key === "Escape") handleClose();
        };
        document.addEventListener("keydown", esc);
        return () => document.removeEventListener("keydown", esc);
    }, []);

    if (!showDeleteModal) return null;

    return (
        <div className="oms-overlay" onClick={handleClose}>
            <div
                className="oms-modal"
                style={{ maxWidth: 420 }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* HEADER */}
                <div className="oms-modal-head">
                    <span
                        className="oms-modal-title"
                        style={{ color: "var(--red)", display: "flex", gap: 6 }}
                    >
                        <FaTrashAlt />
                        Delete Order
                    </span>
                    <button className="oms-icon-btn" onClick={handleClose}>
                        ✕
                    </button>
                </div>

                {/* BODY */}
                <div
                    className="oms-modal-body"
                    style={{ paddingTop: 20, paddingBottom: 20 }}
                >
                    <p style={{ fontSize: 14, lineHeight: 1.7 }}>
                        You are about to delete order{" "}
                        <strong style={{ color: "var(--accent)" }}>
                            {selectedFranchise?.trackingId}
                        </strong>{" "}
                        for customer{" "}
                        <strong>{selectedFranchise?.customerName}</strong>.
                    </p>

                    <p style={{ marginTop: 10, fontSize: 13 }}>
                        This action cannot be undone. <br />
                        Are you sure you want to proceed?
                    </p>
                </div>

                {/* FOOTER */}
                <div className="oms-modal-foot">
                    <button
                        className="oms-btn oms-btn-ghost"
                        onClick={handleClose}
                    >
                        Cancel
                    </button>

                    <button
                        className="oms-btn oms-btn-danger"
                        onClick={handleConfirmDelete}
                        disabled={loading}
                    >
                        {loading ? "Deleting..." : "Confirm Delete"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteFranchiseModal;